import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ClientSmartHub, UserApp } from '@classes/client/client';
import { faEdit, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { OpenDialogEditUserComponent } from 'app/components/dialog/open-dialog-edit-user/open-dialog-edit-user.component';
import { OpendialogSendMailPasswordComponent } from 'app/components/dialog/opendialog-send-mail-password/opendialog-send-mail-password.component';
import { UserService } from '@services/user/user.service';

@Component({
  selector: 'app-application-user-table',
  templateUrl: './application-user-table.component.html',
  styleUrls: ['./application-user-table.component.scss'],
})
export class ApplicationUserTableComponent implements OnInit {
  @Input() users: UserApp[];
  isActive = true;
  faEnvelop = faEnvelope;
  faPen = faEdit;

  dataSource: MatTableDataSource<UserApp>;
  displayedColumns: string[] = [
    'username',
    'email',
    'Gsm',
    'application',
    'isActive',
    'password',
    'EmailNotificationEnabled',
    'SmsNotificationEnabled',
    'Edit',
  ];
  route: any;
  data: any;
  send: boolean;
  dialogRef: any;

  constructor(private userService: UserService, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<UserApp>(this.users);
  }

  activeDesactive(isActive: boolean, id: string): void {
    if (isActive) {
      this.desactiveUser(isActive, id);
    } else {
      this.activeUser(isActive, id);
    }
  }

  private activeUser(isActive: boolean, id: string): void {
    this.userService.ActiveUser(id, isActive).subscribe({
      next: () => {
        this.send = true;
      },
    });
  }
  private desactiveUser(isActive: boolean, id: string): void {
    this.userService.DesactiveUser(id, isActive).subscribe({
      next: () => {
        this.send = true;
      },
    });
  }
  openDialogSendMailPassword(username: string): void {
    const dialogRef = this.dialog.open(OpendialogSendMailPasswordComponent, {
      data: {
        username,
      },
    });
  }

  openDialogEditUsers(client: ClientSmartHub): void {
    const dialogRef = this.dialog.open(OpenDialogEditUserComponent, {
      disableClose: true,
      data: { client },
    });
    dialogRef.afterClosed().subscribe((res) => {});
  }
}
